import React from "react";
import { message } from "antd";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Breadcrumb from "../../components/Breadcrumb";
import PmsCreateComponent from "../../components/Pms/PmsCreate";
import { useGetPMS, useUpdatePMS, useCreatePMS } from "../../hooks/pms.hooks";
import pmsUpdateSchema from "../../schema/pms.schema";

const PmsCreate = () => {
  const title = "General Information";

  const {
    isLoading: isLoadingPMSData,
    data: pmsData,
    refetch: reloadGetPMS,
  } = useGetPMS();

  const {
    reset,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
  } = useForm({
    defaultValues: {
      _id: "",
      pmsName: "",
      pms_name: "",
      pms_version: "",
    },
    mode: "onChange",
    resolver: yupResolver(pmsUpdateSchema),
  });

  const { mutate: updatePMS } = useUpdatePMS({
    onSuccess: () => {
      message.success("PMS Updated Successfully");
      reloadGetPMS();
      reset();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const { mutate: createPMS } = useCreatePMS({
    onSuccess: () => {
      message.success("PMS Created Successfully");
      reloadGetPMS();
      reset();
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const formFirstStepSubmit = async (e) => {
    const data = e;
    if (!e?._id) {
      data.pms_name = e.pmsName;
      delete data.pmsName;
      await createPMS(data);
    } else {
      await updatePMS(e);
    }
  };

  return (
    <div>
      <div className="container_aa">
        <h3>PMS Create and Update</h3>
        <Breadcrumb
          routes={[
            { path: "/", breadcrumbName: "Dashboard" },
            { path: "pms-manager", breadcrumbName: "PMS Create and Update" },
          ]}
        />
      </div>

      <div className="container_ab">
        <div className="container_style_2">
          <div>
            <div style={{ marginBottom: 20 }} />

            <div className="steps-content">
              {!isLoadingPMSData ? (
                <PmsCreateComponent
                  onSubmit={handleSubmit(formFirstStepSubmit)}
                  pmsGetData={pmsData}
                  title={title}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  clearErrors={clearErrors}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PmsCreate;
